module.exports = __webpack_public_path__ + "img/creative-principals-horizontal.9e453cf0.png";